import { useCallback, useEffect, useState } from "react";

import {
  Typography,
  Box,
  Button,
  Snackbar,
  Alert,
  FormControlLabel,
  Checkbox,
  Stack,
  FormGroup,
  Grid,
  Divider,
  Chip,
  Radio,
  RadioGroup,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { Add } from "@mui/icons-material";

import { Link, useParams, useNavigate } from "react-router-dom";

import CardPaciente from "../../components/CardPaciente";

import { ReactComponent as IconDiamond } from "../../images/icon-diamond.svg";
import { ReactComponent as IconSecurity } from "../../images/iconSecurity.svg";
import { ReactComponent as IconInfo } from "../../images/dialogs/info.svg";

import api from "../../services/api";
import { diferencaDatasEmMeses } from "../../utils/diferencaEntreDatasMeses";
import { calcularDiferencaEmAnos } from "../../utils/diferencaEntreDatas";
import { formatDateISO8601, formatDateMethod3 } from "../../utils/formatarData";
import { calculaTempoDataCirurgia } from "../../utils/calculaTempoDataCirurgia";
import { verificaPermissaoDeAcesso } from "../../services/permissoesDeAcesso";
import DetalhesExames from "../../components/DetalhesExames";
import ButtonGoBack from "../../components/Buttons/outlinedGoback";
import DadosClinicosPaciente from "./modulos/DadosClinicosPaciente";
import Card from "./Card";
import HistoricoPaciente from "./modulos/HistoricoPaciente";
import Loading from "../../components/Loading";
import ModalDialogs from "../../components/ModalDialogs";
import { ErrorMessageServeDefault } from "../../utils/mensagensSistema";
import LineChartCustom from "../../components/LineChartCustom";
import PreencherRespostas from "../PrimeiraAvaliacao/preencherRespostas";

import {
  colunasConsultas,
  colunasExames,
  colunasMedicamentos,
  styles,
} from "./data";
import { getItemDecrypt } from "../../utils/cryptoData";
import {
  antecedentepessoaisList,
  comorbidadesList,
  parentescoList,
  sinaisSintomasList,
} from "../PrimeiraAvaliacao/data";
import {
  FieldAutocomplete,
  FieldDatePicker,
  FieldInputText,
} from "../../components/Fields";
import dayjs from "dayjs";
import { requestPrimeiraConsultaDadosClinicosEdit } from "../../services/cadastroService";

const stylesForm = {
  title: {
    fontWeight: "300",
    fontSize: "32px",
    lineHeight: "25px",
    color: "#063F5E",
  },
  formTitle: {
    fontWeight: "bold",
    fontSize: "1.2rem",
    lineHeight: "25px",
    color: "#1E729F",
  },
  subtitle: {
    fontWeight: "500",
    fontSize: "20px",
    lineHeight: "27px",

    marginTop: "20px",
    color: "#3E94C2",
  },
  labelInput: {
    fontFamily: "Nunito",
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "22px",
    letterSpacing: "0em",
    textAlign: "left",
    color: "#063F5E",
    marginBottom: "16px",
  },
  input: {
    fontFamily: "Nunito",
    fontSize: "16px",
    fontWeight: 400,
    lineHeight: "22px",
    color: "#737373",
    textTransform: "capitalize",
  },
};

const consultTypes = {
  1: "Presencial",
  2: "Teleconsulta",
  3: "Híbrida",
};

export default function PerfilCompleto() {
  const { id } = useParams();

  const navigate = useNavigate();
  const [idConsultaEvolucao, setIdConsultaEvolucao] = useState(0);
  const [dataNascimento, setDataNascimento] = useState("");
  const [loadingBackdrop, setLoadingBackdrop] = useState(false);
  const [value, setValue] = useState(0);
  const [loading, setLoading] = useState(true);
  const [dadosClinicos, setDadosClinicos] = useState({});
  const [dadosDiagnosticoELA, setDadosDiagnosticoELA] = useState({});
  const [historicoConsultas, setHistoricoConsultas] = useState({});
  const [historicoExames, setHistoricoExames] = useState({});
  const [historicoMedicamentos, setHistoricoMedicamentos] = useState({});
  const [especialidade, setEspecialidade] = useState(0);
  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");
  const [modalidade, setModalidade] = useState(0);
  const [profissional, setProfissional] = useState(0);
  const [unidadeDeSaude, setUnidadeDeSaude] = useState(0);
  const [profissionalList, setProfissionalList] = useState([]);
  const [especialidadeList, setEspecialidadeList] = useState([]);
  const [unidadeDeSaudeList, setUnidadeDeSaudeList] = useState([]);
  const [atrasoDiagnostico, setAtrasoDiagnostico] = useState(0);
  const [idadeInicioDoenca, setIdadeInicioDoenca] = useState(0);
  const [cirurgias, setCirurgias] = useState([]);
  const [tempoCirurgias, setTempoCirurgias] = useState([]);
  const [cardsInfo, setCardsInfo] = useState({});
  const [existePrimeiraAvaliacao, setExistePrimeiraAvaliacao] = useState();
  const [modalIndicators, setModalIndicators] = useState({
    open: false,
    title: "",
    type: 0,
  });
  const [detalhesExamesSelecionados, setDetalhesExamesSelecionados] = useState(
    {}
  );
  const [open, setOpen] = useState(false);
  const [existeConsultaEmAndamento, setExisteConsultaEmAndamento] =
    useState(false);

  const [openModalMedicamento, setOpenModalMedicamento] = useState(false);
  const [openModalConsulta, setOpenModalConsulta] = useState(false);
  const [dataModalMedicamento, setDataModalMedicamento] = useState();
  const [snackbar, setSnackbar] = useState(null);
  const [pahtRedirect, setPathRedirect] = useState("");
  const [openEdit, setOpenEdit] = useState(false);
  const [consulta, setConsulta] = useState(null);

  const [sinaisSintomas, setSinaisSintomas] = useState([]);
  const [sinaisSintomasOutros, setSinaisSintomasOutros] = useState("");
  const [antecedentesPessoais, setAntecedentesPessoais] = useState([]);
  const [antecedentesPessoaisOutros, setAntecedentesPessoaisOutros] =
    useState("");
  const [comorbidadesSelecionadas, setComorbidadesSelecionadas] = useState([]);
  const [comorbidadesOutras, setComorbidadesOutras] = useState([]);
  const [historicoFamiliarELA, setHistoricoFamiliarELA] = useState([]);
  const [historicoFamiliarELAOutros, setHistoricoFamiliarELAOutros] =
    useState("");
  const [historicoFamiliarDemencia, setHistoricoFamiliarDemencia] = useState(
    []
  );
  const [historicoFamiliarDemenciaOutros, setHistoricoFamiliarDemenciaOutros] =
    useState("");
  const [
    historicoFamiliarDoencaPsiquiatrica,
    setHistoricoFamiliarDoencaPsiquiatrica,
  ] = useState([]);
  const [
    historicoDoencaPsiquiatricaOutros,
    setHistoricoDoencaPsiquiatricaOutros,
  ] = useState([]);
  const [CIDList, setCIDList] = useState([]);
  const [medicamentosUsados, setMedicamentosUsados] = useState([]);
  const [substanciasList, setSubstanciasList] = useState([]);
  const [medicamentosList, setMedicamentosList] = useState([]);

  const [cirurgiasform, setCirurgiasform] = useState({
    checked: undefined,
    qual: "",
    dataCirurgia: "",
    tagCirurgias: [],
  });

  const [checks, setChecks] = useState({
    alimentos: false,
    medicamentos: false,
    outros: false,
    historicoELA: undefined,
    historicoDemencia: undefined,
    historicoDoencaPsiquiatrica: undefined,
    etilismo: false,
    contatoComInseticidas: false,
    ContatoMetaisPesados: false,
    alergiasOuReacoes: undefined,
  });
  const [usoRiluzol, setUsoRiluzol] = useState({
    checked: undefined,
    dataInicioUso: "",
  });
  const [alergiasOuReacoes, setAlergiasOuReacoes] = useState({
    alimentos: [],
    medicamentos: [],
    outros: [],
  });

  const [observacoes, setObservacoes] = useState([]);

  const [charts, setCharts] = useState({
    open: false,
  });

  function handleOpenModalMedicamento(value) {
    setDataModalMedicamento(value);
    setOpenModalMedicamento(true);
  }

  let vinculo = getItemDecrypt("vinculo_ativo");

  useEffect(() => {
    fecthData();
    // add coluna para acoes
    if (colunasMedicamentos[colunasMedicamentos.length - 1].field !== "acoes") {
      colunasMedicamentos.push({
        field: "acoes",
        headerName: "Ações",
        width: 140,
        headerClassName: "color-blue",
        description: "This column has a value getter and is not sortable.",
        sortable: false,
        renderCell: (params) => {
          return (
            <Button
              variant="contained"
              color="primary"
              size="small"
              startIcon={<IconSecurity />}
              sx={{ textTransform: "none" }}
              onClick={() => handleOpenModalMedicamento(params.row)}
            >
              Ver detalhes
            </Button>
          );
        },
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function messageError() {
    setSnackbar({
      children: ErrorMessageServeDefault,
      severity: "error",
    });
  }

  const fecthData = async () => {
    try {
      setLoading(true);

      const primeiraAvaliacaoExiste = await checarSePrimeiraAvaliacaoExiste();
      if (primeiraAvaliacaoExiste) {
        await Promise.all([
          getHistoricos(),
          getListaProfissionais(),
          getListaEspecialidades(),
          getListaUnidadeDeSaude(),
          getDadosPaciente(),
          getCardsInfo(),
          getConsultaAgendada(),
        ]);
        await checaSeExisteConsultaEmAndamento();
      }
    } catch (error) {
      console.error("Erro ao tentar conectar-se ao servidor.", error.message);
      messageError();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getHistoricos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    especialidade,
    modalidade,
    profissional,
    dataInicio,
    dataFim,
    unidadeDeSaude,
  ]);

  async function checarSePrimeiraAvaliacaoExiste() {
    try {
      setLoading(true);
      const permiteAcesso = await verificaPermissaoDeAcesso(id, vinculo.id);

      if (permiteAcesso) {
        const { data } = await api.post(`/checar-consulta/`, {
          id_paciente: id,
          id_vinculo: vinculo.id,
        });

        setExistePrimeiraAvaliacao(data);
        setLoading(false);
        return data;
      } else {
        navigate(`/pacientes/dados-paciente/${id}`);
      }
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  const checkAppointment = async (id, numeroConsulta) => {
    try {
      const { data } = await api.get(`/check-consulta`, {
        params: {
          id_paciente: id,
          nu_consulta: numeroConsulta,
        },
      });
      return data?.consulta || null;
    } catch (error) {
      console.error(`Erro ao verificar consulta ${numeroConsulta}:`, error);
      return null;
    }
  };

  async function checaSeExisteConsultaEmAndamento() {
    try {
      // const { data } = await api.post(`/checar-consulta-em-andamento/`, {
      //   id_paciente: id,
      //   id_vinculo: vinculo.id,
      // });
      const firstAppointment = await checkAppointment(id, 1);

      if (firstAppointment) {
        if (firstAppointment.status === 2) {
          setPathRedirect(`/pacientes/primeira-consulta/${id}`);
          setExisteConsultaEmAndamento(true);
          return;
        } else if (firstAppointment.status === 3) {
          setPathRedirect(`/pacientes/consulta-rotina/${id}`);
          const appointment = await checkAppointment(id, 2);
          setExisteConsultaEmAndamento(
            !!(appointment && appointment.status === 2)
          );
          return;
        }
      }
      const response = await api.post("/historico-consultas/", {
        data: {
          id_paciente: parseInt(id),
          id_estabelecimento: null,
          id_categoria: null,
          id_profissional: null,
          id_perfil: null,
          data_inicial: null,
          data_final: null,
        },
      });

      if (response.data.consultas.length > 0) {
        setPathRedirect(`/pacientes/consulta-rotina/${id}`);
        setExisteConsultaEmAndamento(false);
      } else {
        setPathRedirect(`/pacientes/primeira-consulta/${id}`);
        setExisteConsultaEmAndamento(false);
      }
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  const handleOpenDetalhesExames = (exame) => {
    setDetalhesExamesSelecionados(exame.row);
    setOpen(true);
  };

  const trataCirurgiasDatas = (data) => {
    let elementoEncontrado = data.find(function (objeto) {
      return objeto.idPergunta === 18;
    });

    elementoEncontrado?.resposta.forEach((item) => {
      const nomeCirurgia = item.split("-")[0];
      const data = item.split("-")[1];

      cirurgias.push(nomeCirurgia);
      setCirurgias(cirurgias);

      tempoCirurgias.push(calculaTempoDataCirurgia(data));
      setTempoCirurgias(tempoCirurgias);
    });
  };

  const respostaByPerguntaId = (pergunta_id) => {
    if (dadosClinicos.length > 0) {
      let elementoEncontrado = dadosClinicos.find(function (objeto) {
        return objeto.idPergunta === pergunta_id;
      });

      if (elementoEncontrado) {
        return elementoEncontrado?.resposta;
      } else {
        if (dadosDiagnosticoELA.length > 0) {
          elementoEncontrado = dadosDiagnosticoELA.find(function (objeto) {
            return objeto.idPergunta === pergunta_id;
          });

          return elementoEncontrado?.resposta;
        }
      }
    }
  };

  async function getDadosPaciente() {
    try {
      const { data } = await api.get(`/detalhes-dados-clinicos/${id}`);
      const dadosDiagnosticoELA = await api.get(`/dados-diagnostico-ela/${id}`);
      setDadosClinicos(data);
      setDadosDiagnosticoELA(dadosDiagnosticoELA.data);
      trataCirurgiasDatas(data);
      calculaAtrasoDiagnostico(data, dadosDiagnosticoELA.data);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  const calculaAtrasoDiagnostico = (data, dataDiagnosticoELA) => {
    if (dadosClinicos) {
      var dataDiagnostico = dataDiagnosticoELA.find(function (objeto) {
        return objeto.idPergunta === 205;
      })?.resposta;

      var dataPrimeiroSintoma = data.find(function (objeto) {
        return objeto.idPergunta === 6;
      }).resposta;

      if (dataDiagnostico && dataPrimeiroSintoma) {
        setAtrasoDiagnostico(
          diferencaDatasEmMeses(dataPrimeiroSintoma, dataDiagnostico)
        );
      } else {
        setAtrasoDiagnostico("-");
      }

      calculaIdadeInicioSintomas(dataDiagnostico);
    }
  };

  async function calculaIdadeInicioSintomas(dataDiagnostico) {
    try {
      const { data } = await api.get(`/dadospaciente/${id}`);

      if (dataDiagnostico) {
        const dataNascimento = formatDateISO8601(data.dataNascimento);
        setDataNascimento(dataNascimento);
        const dataDiagnosticoFormatada = formatDateMethod3(dataDiagnostico);

        const idadeDeInicioDaDoenca = calcularDiferencaEmAnos(
          dataNascimento,
          dataDiagnosticoFormatada
        );

        setIdadeInicioDoenca(idadeDeInicioDaDoenca);
      }
    } catch (error) {
      messageError();
      console.error("Ocorreu um erro:", error.message);
    }
  }

  async function getCardsInfo() {
    try {
      const { data } = await api.get(`/cards-info/${id}`);
      const { dadosGraficoPesoIMC, ...rest } = data;
      const newData =
        dadosGraficoPesoIMC?.filter(
          (item) => item.weight !== 0 && item.weight !== null
        ) ?? [];
      setCardsInfo({
        ...rest,
        dadosGraficoPesoIMC: newData,
      });
    } catch (error) {
      console.error("Ocorreu um erro:", error?.message);
    }
  }

  async function getListaProfissionais() {
    try {
      const { data } = await api.post("/profissionais/", {
        id_paciente: parseInt(id),
      });

      setProfissionalList(data);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  async function getListaEspecialidades() {
    try {
      const { data } = await api.post("/especialidades/", {
        id_paciente: parseInt(id),
      });

      setEspecialidadeList(data);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  async function getListaUnidadeDeSaude() {
    try {
      const { data } = await api.post("/estabelecimentos/", {
        id_paciente: parseInt(id),
      });

      setUnidadeDeSaudeList(data);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  async function getHistoricos() {
    try {
      const response = await api.post("/historico-consultas/", {
        data: {
          id_paciente: parseInt(id),
          id_estabelecimento: unidadeDeSaude !== 0 ? unidadeDeSaude : null,
          id_categoria: modalidade !== 0 ? modalidade : null,
          id_profissional: profissional !== 0 ? profissional : null,
          id_perfil: especialidade !== 0 ? especialidade : null,
          data_inicial: dataInicio !== "" ? dataInicio : null,
          data_final: dataFim !== "" ? dataFim : null,
        },
      });

      setHistoricoConsultas(response.data.consultas);
      setHistoricoExames(response.data.exames);
      setHistoricoMedicamentos(response.data.medicamentos);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  const handleIniciarConsulta = async (is_multi) => {
    try {
      //Se profissional é neurologista, o retorno da requisição é true
      //Caso contrário, é false
      const { data } = await api.post(`/checar-perfil-profissional/`, {
        id_vinculo: vinculo.id,
      });

      if (data) {
        navigate(pahtRedirect + `?multidisciplinar=${is_multi}`);
      } else {
        navigate(
          `/pacientes/consulta-demais-profissionais/${id}?multidisciplinar=${is_multi}`
        );
      }
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  };

  const getConsultaAgendada = async () => {
    try {
      const { data } = await api.get(`agenda-paciente/${id}`, {
        params: {
          is_paciente: true,
          status: "1,2",
          data: dayjs().format("YYYY-MM-DD"),
        },
      });
      if (data.length > 0) {
        const response = data[0];
        const today = dayjs().format("YYYY-MM-DD");
        const consultationDate = dayjs(
          response.dataConsulta.split("T")[0]
        ).format("YYYY-MM-DD");
        const status = response.status === 1 || response.status === 2;
        const consultas_evoloucao = response.consultas_evoloucao.find(
          (participante) => participante.id_vinculo === vinculo.id
        );
        const evoloucaoStatus = consultas_evoloucao
          ? consultas_evoloucao.id_status === 1 ||
            consultas_evoloucao.id_status === 2
          : false;
        if (today === consultationDate && status && evoloucaoStatus) {
          setConsulta(response);
        }
      }
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const sinaisSintomasOpcaoSelecionada = (valor) => {
    return sinaisSintomas.includes(valor);
  };

  const antecedentesPessoaisSelecionada = (valor) => {
    return antecedentesPessoais.includes(valor);
  };

  const comorbidadeOpcaoSelecionada = (valor) => {
    return comorbidadesSelecionadas.includes(valor);
  };

  const historicoDoencaPsiquiatricaOpcaoSelecionada = (valor) => {
    return historicoFamiliarDoencaPsiquiatrica.includes(valor);
  };

  const historicoELAOpcaoSelecionada = (valor) => {
    return historicoFamiliarELA.includes(valor);
  };

  const historicoDemenciaOpcaoSelecionada = (valor) => {
    return historicoFamiliarDemencia.includes(valor);
  };

  async function getCIDList() {
    try {
      const { data } = await api.get("/buscacid/");
      setCIDList(data.cids);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }
  async function getMedicamentosList() {
    try {
      const { data } = await api.post("/medicamentos/", {
        descricao: "",
        apenasNome: true,
      });

      setMedicamentosList(data.medicines);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }
  async function getSubstanciasList() {
    try {
      const { data } = await api.post("/medicamentos/", {
        descricao: "",
        apenasSubstancia: true,
      });

      setSubstanciasList(data.medicines);
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }

  const mostrarLabelComorbidadesOutras = (comorb) => {
    if (comorb.co_categoria) {
      return `${comorb.co_categoria} - ${comorb.no_categoria}`;
    } else {
      return comorb;
    }
  };

  const atualizarComorbidadesOutras = (v) => {
    if (v.no_descricao) {
      setComorbidadesOutras((prevState) =>
        comorbidadesOutras.filter(
          (data) => data.no_categoria !== v.no_categoria
        )
      );
    } else {
      setComorbidadesOutras((prevState) =>
        comorbidadesOutras.filter((data) => data !== v)
      );
    }
  };

  async function getDadosPrimeiraAvaliacao() {
    try {
      const { data } = await api.post(`/respostas-primeira-consulta/${id}`);
      return data;
    } catch (error) {
      console.error("Ocorreu um erro:", error.message);
    }
  }
  const handleOpenEdit = async () => {
    setLoadingBackdrop(true);
    await Promise.all([
      getCIDList(),
      getMedicamentosList(),
      getSubstanciasList(),
    ]);
    const { idConsultaEvolucao, question } = await getDadosPrimeiraAvaliacao();
    if (question && question.length > 0) {
      const camposAdicionais = {
        setEstadoInicioDoenca: () => {},
        setMunicipioInicioDoenca: () => {},
        fetchMunicipio: () => {},
        setTempoMoradiaMunicipio: () => {},
        setLocalPrimeiroSintoma: () => {},
        setDataPrimeiroSintoma: () => {},
        setIdadeInicioSintomas: () => {},
        setSinaisSintomas,
        setComorbidadesSelecionadas,
        setComorbidadesOutras,
        setChecks,
        setHistoricoFamiliarELA,
        setHistoricoFamiliarDemencia,
        setUsoRiluzol,
        setAnamnese: () => {},
        setAltura: () => {},
        setPeso: () => {},
        setImc: () => {},
        setSinaisSintomasOutros,
        setAntecedentesPessoais,
        setAntecedentesPessoaisOutros,
        setCirurgias: setCirurgiasform,
        setHistoricoFamiliarDoencaPsiquiatrica,
        setHistoricoDoencaPsiquiatricaOutros,
        setHistoricoFamiliarELAOutros,
        setHistoricoFamiliarDemenciaOutros,
        setMedicamentosUsados,
        setAlergiasOuReacoes,
        setObservacoes,
      };
      PreencherRespostas(question, camposAdicionais);
      setIdConsultaEvolucao(idConsultaEvolucao);
    }

    setOpenEdit(true);
    setLoadingBackdrop(false);
  };

  const handleCloseEdit = () => {
    setSinaisSintomas([]);

    setSinaisSintomasOutros("");
    setAntecedentesPessoais([]);
    setAntecedentesPessoaisOutros("");
    setComorbidadesSelecionadas([]);

    setComorbidadesOutras([]);

    setCirurgiasform({
      tagCirurgias: [],
      qual: "",
      dataCirurgia: "",
      checked: undefined,
    });
    setHistoricoFamiliarELA([]);
    setHistoricoFamiliarELAOutros("");
    setHistoricoFamiliarDoencaPsiquiatrica([]);
    setHistoricoDoencaPsiquiatricaOutros("");
    setHistoricoFamiliarDemencia([]);
    setHistoricoFamiliarDemenciaOutros("");
    setUsoRiluzol({
      checked: undefined,
      dataInicioUso: "",
    });

    setMedicamentosUsados([]);

    setAlergiasOuReacoes({
      alimentos: [],
      medicamentos: [],
      outros: [],
    });
    setObservacoes(respostaByPerguntaId(33) ?? "");

    setChecks({
      alimentos: false,
      medicamentos: false,
      outros: false,
      historicoELA: undefined,
      historicoDemencia: undefined,
      historicoDoencaPsiquiatrica: undefined,
      etilismo: false,
      contatoComInseticidas: false,
      ContatoMetaisPesados: false,
      alergiasOuReacoes: undefined,
    });

    setOpenEdit(false);
  };

  const handleAdicionarCirurgia = useCallback(() => {
    if (cirurgiasform.qual !== "" && cirurgiasform.dataCirurgia !== "") {
      setCirurgiasform((prevState) => ({
        ...prevState,
        tagCirurgias: [
          ...prevState.tagCirurgias,
          `${prevState.qual} - ${dayjs(prevState.dataCirurgia).format(
            "MM/YYYY"
          )}`,
        ],
        qual: "",
        dataCirurgia: "",
      }));
    } else {
      setSnackbar({
        children: "Informe o nome da cirurgia e a data da cirurgia.",
        severity: "error",
      });
    }
  }, [cirurgiasform]);

  const handlechecked = (e, setData) => {
    const { value, checked } = e.target;

    if (checked) {
      setData((prevState) => [...prevState, value]);
    } else {
      setData((prevState) => [...prevState.filter((e) => e !== value)]);
    }
  };
  const selecionarComorbidadesOutras = () => {
    return comorbidadesOutras.map((comorb) => {
      if (comorb.co_categoria) {
        return `${comorb.co_categoria} - ${comorb.no_categoria}`;
      } else {
        return comorb;
      }
    });
  };
  const opcaoSimNaoSelecionada = (resposta) => {
    if (resposta) {
      return "50";
    }

    if (resposta === null || resposta === undefined || resposta === "") {
      return "";
    }

    return "51";
  };

  const handleSubmitEdit = async (e) => {
    e.preventDefault();
    setLoadingBackdrop(true);
    const data = {
      id_vinculo: vinculo.id,
      id_paciente: parseInt(id),
      id_consulta_evolucao: idConsultaEvolucao,
      nu_consulta: 0,
      sinaisSintomas,
      sinaisSintomasOutros: sinaisSintomas.includes("34")
        ? sinaisSintomasOutros
        : "",
      antecedentesPessoais,
      antecedentesPessoaisOutros: antecedentesPessoais.includes("34")
        ? antecedentesPessoaisOutros
        : "",
      comorbidadesSelecionadas,
      comorbidadeOutras: selecionarComorbidadesOutras(),
      possuiCirurgias: cirurgiasform.checked ? "50" : "51",
      listagemCirurgias: cirurgiasform.tagCirurgias,
      historicoFamiliarELA: opcaoSimNaoSelecionada(checks.historicoELA),
      historicoFamiliarELAQuem: checks.historicoELA ? historicoFamiliarELA : [],
      historicoFamiliarELAOutros:
        checks.historicoELA && historicoFamiliarELA.includes("34")
          ? historicoFamiliarELAOutros
          : "",
      historicoFamiliarDemencia: opcaoSimNaoSelecionada(
        checks.historicoDemencia
      ),
      historicoFamiliarDemenciaQuem: checks.historicoDemencia
        ? historicoFamiliarDemencia
        : [],
      historicoFamiliarDemenciaOutros:
        checks.historicoDemencia && historicoFamiliarDemencia.includes("34")
          ? historicoFamiliarDemenciaOutros
          : "",
      historicoFamiliarDoencaPsiquiatrica: opcaoSimNaoSelecionada(
        checks.historicoDoencaPsiquiatrica
      ),
      historicoFamiliarDoencaPsiquiatricaQuem:
        checks.historicoDoencaPsiquiatrica
          ? historicoFamiliarDoencaPsiquiatrica
          : [],
      historicoDoencaPsiquiatricaOutros:
        checks.historicoDoencaPsiquiatrica &&
        historicoFamiliarDoencaPsiquiatrica.includes("34")
          ? historicoDoencaPsiquiatricaOutros
          : "",
      usaRiluzol: usoRiluzol.checked ? "50" : "51",
      dataRiluzol: usoRiluzol.dataInicioUso,
      medicamentosUsados,
      alergiaAlimentos: checks.alergiasOuReacoes
        ? alergiasOuReacoes.alimentos
        : [],
      alergiaMedicamentos: checks.alergiasOuReacoes
        ? alergiasOuReacoes.medicamentos
        : [],
      alergiaOutros: checks.alergiasOuReacoes ? alergiasOuReacoes.outros : [],
      observacoes,
    };
    const response = await requestPrimeiraConsultaDadosClinicosEdit(data);
    if (response) {
      setSnackbar({
        children: "Alterações salvas com sucesso.",
        severity: "success",
      });
      handleCloseEdit();
      getDadosPaciente();
    } else {
      setSnackbar({
        children: "Erro ao salvar alterações.",
        severity: "error",
      });
    }
    setLoadingBackdrop(false);
  };

  const handleSelectedChart = (value) => {
    const dataCharts = {};

    switch (value) {
      case "weight":
        dataCharts.title = "Histórico de peso";
        dataCharts.data = cardsInfo.dadosGraficoPesoIMC;
        dataCharts.name = "peso";
        dataCharts.KeyXAxis = "date";
        dataCharts.KeyYAxis = "weight";
        dataCharts.open = true;
        break;
      case "imc":
        dataCharts.title = "Histórico de IMC";
        dataCharts.data = cardsInfo.dadosGraficoPesoIMC;
        dataCharts.name = "imc";
        dataCharts.KeyXAxis = "date";
        dataCharts.KeyYAxis = "imc";
        dataCharts.open = true;
        break;
      case "funcional":
        dataCharts.title = "Histórico de escala";
        dataCharts.data = cardsInfo.dadosGraficoEscala;
        dataCharts.name = "Profissional";
        dataCharts.KeyXAxis = "date";
        dataCharts.KeyYAxis = "value_ps";
        dataCharts.lineSecundary = true;
        dataCharts.KeyYAxislLineSecundary = "value_pt";
        dataCharts.namelineSecundary = "Paciente";
        dataCharts.open = true;
        break;
      case "CVF":
        dataCharts.title = "Histórico de CVF";
        dataCharts.data = cardsInfo.dadosGraficoCVF;
        dataCharts.name = "CVF";
        dataCharts.KeyXAxis = "date";
        dataCharts.KeyYAxis = "value_ps";
        dataCharts.open = true;
        break;
      default:
        console.log("Invalid value:", value);
    }
    setCharts(dataCharts);
  };

  if (loading) {
    return <Loading />;
  }

  return (
    <Box
      sx={{
        width: "100%",
        boxSizing: "border-box !important",
        paddingBottom: "40px",
      }}
    >
      <Box
        component="div"
        sx={{
          boxSizing: "border-box !important",
          width: "100% !important",
          flex: 1,
        }}
      >
        <ButtonGoBack />

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <Box component="h1" style={styles.subtitle}>
            Prontuário do paciente
          </Box>
          <Button
            variant="contained"
            endIcon={<Add />}
            onClick={() =>
              consulta
                ? setOpenModalConsulta(true)
                : handleIniciarConsulta(false)
            }
            sx={{
              textTransform: "none",
              fontSize: "18px",
              height: "40px",
              boxSizing: "border-box !important",
              borderRadius: "5px",
              padding: "8px 16px",
              fontWeight: "500",
            }}
            disabled={!existePrimeiraAvaliacao}
          >
            {existeConsultaEmAndamento
              ? "Continuar consulta"
              : "Iniciar consulta"}
          </Button>
        </Box>

        <>
          <CardPaciente id={id} />
          {existePrimeiraAvaliacao ? (
            <>
              <Box position="relative">
                <DadosClinicosPaciente
                  respostaByPerguntaId={respostaByPerguntaId}
                  idadeInicioDoenca={idadeInicioDoenca}
                  atrasoDiagnostico={atrasoDiagnostico}
                  cirurgias={cirurgias}
                  tempoCirurgias={tempoCirurgias}
                  onEdit={() => handleOpenEdit()}
                />
              </Box>

              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                  gap: "16px 16px",
                  mt: 2,
                  mb: 2,
                }}
              >
                <Card
                  title={`${cardsInfo.pesoAtual ?? "-"} kg`}
                  text="Peso atual"
                  chipLabel={cardsInfo.historicoPeso ?? "-"}
                  onClick={() => handleSelectedChart("weight")}
                />
                <Card
                  title={`${cardsInfo.imcAtual ?? "-"} kg/m²`}
                  text="IMC atual"
                  chipLabel={cardsInfo.historicoIMC ?? ""}
                  onClick={() => handleSelectedChart("imc")}
                />
                <Card
                  title={`${cardsInfo.escalaAtual ?? "-"} pontos`}
                  text="Escala funcional"
                  chipLabel={cardsInfo.historicoEscala ?? "-"}
                  onClick={() => handleSelectedChart("funcional")}
                />
                <Card
                  title={`${cardsInfo.CVFatual ?? "-"} pontos`}
                  text="CVF atual"
                  chipLabel={cardsInfo.historicoCVF ?? "-"}
                  onClick={() => handleSelectedChart("CVF")}
                />
              </Box>

              <HistoricoPaciente
                especialidade={especialidade}
                setEspecialidade={setEspecialidade}
                especialidadeList={especialidadeList}
                dataInicio={dataInicio}
                setDataInicio={setDataInicio}
                dataFim={dataFim}
                setDataFim={setDataFim}
                modalidade={modalidade}
                setModalidade={setModalidade}
                profissional={profissional}
                setProfissional={setProfissional}
                profissionalList={profissionalList}
                unidadeDeSaude={unidadeDeSaude}
                setUnidadeDeSaude={setUnidadeDeSaude}
                unidadeDeSaudeList={unidadeDeSaudeList}
                value={value}
                handleChange={handleChange}
                historicoConsultas={historicoConsultas}
                colunasConsultas={colunasConsultas}
                historicoExames={historicoExames}
                colunasExames={colunasExames}
                handleOpenDetalhesExames={handleOpenDetalhesExames}
                historicoMedicamentos={historicoMedicamentos}
                colunasMedicamentos={colunasMedicamentos}
              />
            </>
          ) : (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                justifyContent: "space-around",
                textAlign: "center",
              }}
            >
              <IconInfo />
              <Typography style={styles.subtitle}>
                Este paciente ainda não possui a primeira avaliação cadastrada
              </Typography>
              <Typography sx={{ fontSize: "1rem", color: "#063F5E" }}>
                <strong>
                  Caso deseje cadastrar, clique em "Cadastrar primeira
                  avaliação"
                </strong>
              </Typography>
              <Button
                sx={{ textTransform: "none", mt: 3 }}
                variant="contained"
                startIcon={<Add />}
                component={Link}
                to={"/pacientes/primeira-avaliacao/" + id}
              >
                Cadastrar primeira avaliação
              </Button>
            </Box>
          )}
        </>

        <ModalDialogs
          open={charts.open}
          onClose={() =>
            setCharts({
              open: false,
            })
          }
          title={charts.title}
          maxWidth="1000px"
          body={
            <Box
              width={{ xs: "360px", sm: "550px", md: "800px", lg: "1000px" }}
              p={2}
            >
              {/* {[1, 2].includes(modalIndicators.type) ? (
                <>
                  <LineChartCustom
                    data={cardsInfo.dadosGraficoPesoIMC}
                    KeyXAxis="date"
                    KeyYAxis={modalIndicators.type === 2 ? "imc" : "weight"}
                    name={modalIndicators.type === 2 ? "imc" : "peso"}
                  />
                </>
              ) : (
                <>
                  <LineChartCustom
                    data={cardsInfo.dadosGraficoEscala}
                    lineSecundary={true}
                    KeyYAxislLineSecundary="value_pt"
                    namelineSecundary="Paciente"
                    name="Profissional"
                    KeyXAxis="date"
                    KeyYAxis="value_ps"
                  />
                </>
              )} */}

              <LineChartCustom
                data={charts?.data}
                KeyXAxis={charts?.KeyXAxis}
                KeyYAxis={charts?.KeyYAxis}
                name={charts?.name}
                {...(charts?.lineSecundary && {
                  lineSecundary: true,
                  KeyYAxislLineSecundary: charts?.KeyYAxislLineSecundary,
                  namelineSecundary: charts?.namelineSecundary,
                })}
              />
            </Box>
          }
        />

        {open && (
          <DetalhesExames
            open={open}
            setOpen={setOpen}
            id_vinculo={vinculo.id}
            id_consulta_evolucao={
              detalhesExamesSelecionados.exams[0].idConsultaEvolucao
            }
            detalhesExamesSelecionados={detalhesExamesSelecionados}
            getExamesConsulta={getHistoricos}
          />
        )}
        <ModalDialogs
          open={openModalMedicamento}
          onClose={() => setOpenModalMedicamento(false)}
          title="Medicamento"
          maxWidth="700px"
          body={
            <Box
              sx={{
                gap: "20px",
                display: "flex",
                flexDirection: "column",
                textAlign: "start",
              }}
            >
              {dataModalMedicamento && (
                <>
                  <Typography
                    component="h3"
                    sx={{
                      fontWeight: "700",
                      fontSize: "20px",
                    }}
                  >
                    {dataModalMedicamento.substancia} -{" "}
                    {dataModalMedicamento.medicamento}
                  </Typography>
                  <Box>
                    <Typography component="p">
                      <Typography
                        component="strong"
                        sx={{
                          fontWeight: "700",
                          marginRight: "10px",
                        }}
                      >
                        Duração do tratamento:
                      </Typography>
                      {dataModalMedicamento.duracaoTratamento}
                    </Typography>
                    <Typography component="p">
                      {dataModalMedicamento.posologia}
                    </Typography>
                    <Typography component="p">
                      {dataModalMedicamento.observacao}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography component="p">
                      <Typography
                        component="strong"
                        sx={{
                          fontWeight: "700",
                          marginRight: "10px",
                        }}
                      >
                        Data da prescrição:
                      </Typography>
                      {dataModalMedicamento.criadoEm}
                    </Typography>
                    <Typography component="p">
                      <Typography
                        component="strong"
                        sx={{
                          fontWeight: "700",
                          marginRight: "10px",
                        }}
                      >
                        Profissional:
                      </Typography>
                      {dataModalMedicamento.cadastradoPor.nome}
                    </Typography>
                    <Typography component="p">
                      <Typography
                        component="strong"
                        sx={{
                          fontWeight: "700",
                          marginRight: "10px",
                        }}
                      >
                        Vinculo:
                      </Typography>
                      {dataModalMedicamento.cadastradoPor.perfil}
                    </Typography>
                    <Typography component="p">
                      <Typography
                        component="strong"
                        sx={{
                          fontWeight: "700",
                          marginRight: "10px",
                        }}
                      >
                        CRM/UF:
                      </Typography>
                      {dataModalMedicamento.cadastradoPor.numeroConselho}/
                      {dataModalMedicamento.cadastradoPor.crmUf}
                    </Typography>
                    <Typography component="p">
                      <Typography
                        component="strong"
                        sx={{
                          fontWeight: "700",
                          marginRight: "10px",
                        }}
                      >
                        Estabelecimento de saúde:
                      </Typography>
                      {dataModalMedicamento.cadastradoPor.unidadeDeSaude}
                    </Typography>
                  </Box>
                </>
              )}
            </Box>
          }
        />

        <ModalDialogs
          open={openEdit}
          onClose={handleCloseEdit}
          title="Dados clínicos"
          maxWidth="700px"
          body={
            <Box
              sx={{
                gap: "8px",
                display: "flex",
                flexDirection: "column",
                textAlign: "start",
                width: { xs: "100%", md: "700px" },

                maxHeight: "600px",
              }}
              component={"form"}
              onSubmit={handleSubmitEdit}
            >
              <Typography style={stylesForm.subtitle}>
                Sinais e sintomas
              </Typography>

              <Stack
                component="label"
                direction="row"
                sx={stylesForm.labelInput}
              >
                Selecione todos que se aplicam:
              </Stack>
              <Stack>
                <FormGroup
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                    boxSizing: "border-box !important",
                    marginBottom: "20px",
                    gap: "0px 24px",
                    gridAutoRows: "40px",

                    "& label span:first-of-type": {
                      color: "#3E94C2",
                    },
                  }}
                >
                  {sinaisSintomasList.map((item) => (
                    <FormControlLabel
                      key={item.value}
                      control={<Checkbox sx={{ color: "#3E94C2" }} />}
                      label={item.label}
                      value={item.value}
                      checked={sinaisSintomasOpcaoSelecionada(item.value)}
                      onClick={(e) => handlechecked(e, setSinaisSintomas)}
                    />
                  ))}
                  <Grid container direction="row" alignItems="center">
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Outros"
                      value="34"
                      checked={sinaisSintomasOpcaoSelecionada("34")}
                      onClick={(e) => handlechecked(e, setSinaisSintomas)}
                    />
                    <FieldInputText
                      label=""
                      value={sinaisSintomasOutros}
                      setValue={(value) => {
                        setSinaisSintomasOutros(value);
                      }}
                    />
                  </Grid>
                </FormGroup>
              </Stack>

              <Divider sx={{ mb: 2, mt: 2 }} />
              <Typography style={stylesForm.subtitle}>
                Antecedente pessoais
              </Typography>
              <Stack direction="row" sx={stylesForm.labelInput}>
                Selecione todos que se aplicam:
              </Stack>
              <Stack>
                <FormGroup
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                    boxSizing: "border-box !important",
                    marginBottom: "20px",
                    gap: "0px 24px",
                    gridAutoRows: "40px",

                    "& label span:first-of-type": {
                      color: "#3E94C2",
                    },
                  }}
                >
                  {antecedentepessoaisList.map((item) => (
                    <FormControlLabel
                      key={item.value}
                      control={<Checkbox />}
                      label={item.label}
                      value={item.value}
                      onClick={(e) => handlechecked(e, setAntecedentesPessoais)}
                      checked={antecedentesPessoaisSelecionada(item.value)}
                    />
                  ))}

                  <Grid container direction="row" alignItems="center">
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Outros"
                      value="34"
                      onClick={(e) => handlechecked(e, setAntecedentesPessoais)}
                      checked={antecedentesPessoaisSelecionada("34")}
                    />
                    <FieldInputText
                      label=""
                      value={antecedentesPessoaisOutros}
                      setValue={(value) => {
                        setAntecedentesPessoaisOutros(value);
                      }}
                    />
                  </Grid>
                </FormGroup>
              </Stack>

              <Divider sx={{ mb: 2, mt: 2 }} />
              <Typography style={stylesForm.subtitle}>Comorbidades</Typography>
              <Stack direction="row" sx={stylesForm.labelInput}>
                Selecione todos que se aplicam:
              </Stack>
              <Stack>
                <FormGroup
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                    boxSizing: "border-box !important",
                    marginBottom: "20px",
                    gap: "0px 24px",
                    gridAutoRows: "40px",

                    "& label span:first-of-type": {
                      color: "#3E94C2",
                    },
                  }}
                >
                  {comorbidadesList.map((item) => (
                    <FormControlLabel
                      key={item.value}
                      control={<Checkbox />}
                      label={item.label}
                      value={item.value}
                      checked={comorbidadeOpcaoSelecionada(item.value)}
                      onClick={(e) =>
                        handlechecked(e, setComorbidadesSelecionadas)
                      }
                    />
                  ))}
                </FormGroup>
              </Stack>
              <FieldAutocomplete
                label="Selecione outras comorbidades acometidas pelo paciente"
                multiple
                options={CIDList}
                getOptionLabel={(option) =>
                  `${option.co_categoria} - ${option.no_categoria}` || ""
                }
                freeSolo
                value={comorbidadesOutras}
                setValue={(e, newValue) => {
                  const uniqueValues = [
                    ...new Set(newValue.map((comorbidade) => comorbidade)),
                  ];
                  setComorbidadesOutras(uniqueValues);
                }}
                renderTags={() => null}
              />
              <Stack direction="row" flexWrap="wrap" sx={{ mt: 1 }}>
                {comorbidadesOutras.map((v) => (
                  <Chip
                    sx={{
                      background: "#D3E3EB",
                      color: "#1E729F",
                      margin: "4px",
                    }}
                    key={v.co_categoria}
                    label={mostrarLabelComorbidadesOutras(v)}
                    onDelete={(valor) => {
                      atualizarComorbidadesOutras(v);
                    }}
                  />
                ))}
              </Stack>
              <Divider sx={{ mb: 2, mt: 2 }} />
              <Typography style={stylesForm.subtitle}>Cirurgias</Typography>

              <Stack
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
                  boxSizing: "border-box !important",
                  marginBottom: "20px",
                  gap: "16px 24px",
                  alignItems: "start",
                }}
              >
                <Stack>
                  <Stack direction="row" sx={stylesForm.labelInput}>
                    Realizou cirurgias? <IconDiamond fill="#FC8518" />
                  </Stack>

                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                  >
                    <FormControlLabel
                      value="sim"
                      control={
                        <Radio
                          onChange={() =>
                            setCirurgiasform((prevState) => ({
                              ...prevState,
                              checked: true,
                            }))
                          }
                        />
                      }
                      label="Sim"
                      checked={cirurgiasform.checked}
                    />
                    <FormControlLabel
                      value="não"
                      control={
                        <Radio
                          onChange={() =>
                            setCirurgiasform((prevState) => ({
                              ...prevState,
                              checked: false,
                            }))
                          }
                        />
                      }
                      label="Não"
                      checked={cirurgiasform.checked === false}
                    />
                  </RadioGroup>
                </Stack>

                {cirurgiasform.checked && (
                  <>
                    <FieldInputText
                      label="Quais?"
                      setValue={(value) => {
                        setCirurgiasform((prevState) => ({
                          ...prevState,
                          qual: value,
                        }));
                      }}
                      placeholder="Digite"
                      value={cirurgiasform.qual}
                    />
                    <FieldDatePicker
                      label="Data da cirurgia"
                      setValue={(value) => {
                        setCirurgiasform((prevState) => ({
                          ...prevState,
                          dataCirurgia: value === null ? "" : value,
                        }));
                      }}
                      labelDatePicker={"mês de ano"}
                      openTo="year"
                      views={["year", "month"]}
                      maxDate={dayjs(new Date())}
                      minDate={dayjs(dataNascimento)}
                      format="MMMM YYYY"
                      value={cirurgiasform.dataCirurgia}
                    />

                    <Button
                      sx={{
                        height: "40px",
                        marginTop: "26px",
                      }}
                      variant="contained"
                      onClick={handleAdicionarCirurgia}
                    >
                      + Adicionar
                    </Button>
                  </>
                )}
              </Stack>
              <Stack direction="row" flexWrap="wrap" sx={{ mt: 1 }}>
                {cirurgiasform.tagCirurgias.map((v, index) => (
                  <Chip
                    sx={{
                      background: "#D3E3EB",
                      color: "#1E729F",
                      margin: "4px",
                    }}
                    key={index}
                    label={v}
                    onDelete={(valor) => {
                      setCirurgiasform((prevState) => ({
                        ...prevState,
                        tagCirurgias: prevState.tagCirurgias.filter(
                          (data) => data !== v
                        ),
                      }));
                    }}
                  />
                ))}
              </Stack>

              <Divider sx={{ mb: 2, mt: 2 }} />
              <Typography style={stylesForm.subtitle}>
                Histórico familiar
              </Typography>
              <Stack
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))",
                  boxSizing: "border-box !important",
                  gap: "16px 24px",
                  color: "#333333",
                }}
              >
                <Stack width="100%">
                  <Stack direction="row" sx={stylesForm.labelInput}>
                    Histórico familiar de doença psiquiátrica?
                  </Stack>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                  >
                    <FormControlLabel
                      value="sim"
                      control={
                        <Radio
                          onChange={() =>
                            setChecks((prevState) => ({
                              ...prevState,
                              historicoDoencaPsiquiatrica: true,
                            }))
                          }
                        />
                      }
                      label="Sim"
                      checked={checks.historicoDoencaPsiquiatrica}
                    />
                    <FormControlLabel
                      value="não"
                      control={
                        <Radio
                          onChange={() =>
                            setChecks((prevState) => ({
                              ...prevState,
                              historicoDoencaPsiquiatrica: false,
                            }))
                          }
                        />
                      }
                      label="Não"
                      checked={checks.historicoDoencaPsiquiatrica === false}
                    />
                  </RadioGroup>

                  {checks.historicoDoencaPsiquiatrica && (
                    <>
                      <Stack direction="row" sx={stylesForm.labelInput}>
                        Quem?
                      </Stack>
                      <Stack>
                        <FormGroup
                          sx={{
                            display: "grid",
                            gridTemplateColumns: "repeat(2,1fr)",
                            boxSizing: "border-box !important",
                            gap: "0px 24px",
                            gridAutoRows: "40px",

                            "& label span:first-of-type": {
                              color: "#3E94C2",
                            },
                          }}
                        >
                          {parentescoList.map((item) => (
                            <FormControlLabel
                              key={item.value}
                              control={<Checkbox />}
                              label={item.label}
                              value={item.value}
                              checked={historicoDoencaPsiquiatricaOpcaoSelecionada(
                                item.value
                              )}
                              onClick={(e) =>
                                handlechecked(
                                  e,
                                  setHistoricoFamiliarDoencaPsiquiatrica
                                )
                              }
                            />
                          ))}

                          <FieldInputText
                            disabled={
                              !historicoFamiliarDoencaPsiquiatrica.includes(
                                "34"
                              )
                            }
                            type="text"
                            value={historicoDoencaPsiquiatricaOutros}
                            setValue={(value) =>
                              setHistoricoDoencaPsiquiatricaOutros(value)
                            }
                          />
                        </FormGroup>
                      </Stack>
                    </>
                  )}
                </Stack>

                <Stack width="100%">
                  <Stack direction="row" sx={stylesForm.labelInput}>
                    Histórico familiar de ELA?
                  </Stack>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                  >
                    <FormControlLabel
                      value="sim"
                      checked={checks.historicoELA}
                      control={
                        <Radio
                          onChange={() =>
                            setChecks((prevState) => ({
                              ...prevState,
                              historicoELA: true,
                            }))
                          }
                        />
                      }
                      label="Sim"
                    />
                    <FormControlLabel
                      value="não"
                      checked={checks.historicoELA === false}
                      control={
                        <Radio
                          onChange={() =>
                            setChecks((prevState) => ({
                              ...prevState,
                              historicoELA: false,
                            }))
                          }
                        />
                      }
                      label="Não"
                    />
                  </RadioGroup>

                  {checks.historicoELA && (
                    <>
                      <Stack direction="row" sx={stylesForm.labelInput}>
                        Quem?
                      </Stack>
                      <Stack>
                        <FormGroup
                          sx={{
                            display: "grid",
                            gridTemplateColumns: "repeat(2,1fr)",
                            boxSizing: "border-box !important",
                            gap: "0px 24px",
                            gridAutoRows: "40px",

                            "& label span:first-of-type": {
                              color: "#3E94C2",
                            },
                          }}
                        >
                          {parentescoList.map((item) => (
                            <FormControlLabel
                              key={item.value}
                              control={<Checkbox />}
                              label={item.label}
                              value={item.value}
                              checked={historicoELAOpcaoSelecionada(item.value)}
                              onClick={(e) =>
                                handlechecked(e, setHistoricoFamiliarELA)
                              }
                            />
                          ))}
                          <FieldInputText
                            disabled={!historicoFamiliarELA.includes("34")}
                            value={historicoFamiliarELAOutros}
                            setValue={(value) => {
                              setHistoricoFamiliarELAOutros(value);
                            }}
                          />
                        </FormGroup>
                      </Stack>
                    </>
                  )}
                </Stack>

                <Stack width="100%">
                  <Stack direction="row" sx={stylesForm.labelInput}>
                    Histórico familiar de demência?
                  </Stack>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                  >
                    <FormControlLabel
                      value="sim"
                      checked={checks.historicoDemencia}
                      control={
                        <Radio
                          onChange={() =>
                            setChecks((prevState) => ({
                              ...prevState,
                              historicoDemencia: true,
                            }))
                          }
                        />
                      }
                      label="Sim"
                    />
                    <FormControlLabel
                      value="não"
                      checked={checks.historicoDemencia === false}
                      control={
                        <Radio
                          onChange={() =>
                            setChecks((prevState) => ({
                              ...prevState,
                              historicoDemencia: false,
                            }))
                          }
                        />
                      }
                      label="Não"
                    />
                  </RadioGroup>

                  {checks.historicoDemencia && (
                    <>
                      <Stack direction="row" sx={stylesForm.labelInput}>
                        Quem?
                      </Stack>
                      <Stack>
                        <FormGroup
                          sx={{
                            display: "grid",
                            gridTemplateColumns: "repeat(2,1fr)",
                            boxSizing: "border-box !important",
                            gap: "0px 24px",
                            gridAutoRows: "40px",

                            "& label span:first-of-type": {
                              color: "#3E94C2",
                            },
                          }}
                        >
                          {parentescoList.map((item) => (
                            <FormControlLabel
                              key={item.value}
                              control={<Checkbox />}
                              label={item.label}
                              value={item.value}
                              checked={historicoDemenciaOpcaoSelecionada(
                                item.value
                              )}
                              onClick={(e) =>
                                handlechecked(e, setHistoricoFamiliarDemencia)
                              }
                            />
                          ))}
                          <FieldInputText
                            disabled={!historicoFamiliarDemencia.includes("34")}
                            value={historicoFamiliarDemenciaOutros}
                            setValue={(value) =>
                              setHistoricoFamiliarDemenciaOutros(value)
                            }
                          />
                        </FormGroup>
                      </Stack>
                    </>
                  )}
                </Stack>
              </Stack>

              <Divider sx={{ mb: 2, mt: 2 }} />
              <Typography style={stylesForm.subtitle}>
                Medicamentos do paciente
              </Typography>
              <Stack
                direction={{ md: "row", sm: "column" }}
                spacing={4}
                sx={{ mb: 2 }}
              >
                <Stack>
                  <Stack direction="row" sx={stylesForm.labelInput}>
                    Uso de riluzol? <IconDiamond fill="#FC8518" />
                  </Stack>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                  >
                    <FormControlLabel
                      value="sim"
                      checked={usoRiluzol.checked}
                      control={
                        <Radio
                          onChange={() =>
                            setUsoRiluzol((prevState) => ({
                              ...prevState,
                              checked: true,
                            }))
                          }
                        />
                      }
                      label="Sim"
                    />
                    <FormControlLabel
                      value="não"
                      checked={usoRiluzol.checked === false}
                      control={
                        <Radio
                          onChange={() =>
                            setUsoRiluzol((prevState) => ({
                              ...prevState,
                              checked: false,
                            }))
                          }
                        />
                      }
                      label="Não"
                    />
                  </RadioGroup>
                </Stack>

                {usoRiluzol.checked && (
                  <Stack>
                    <FieldDatePicker
                      label="Data de início do uso"
                      value={usoRiluzol.dataInicioUso}
                      setValue={(value) =>
                        setUsoRiluzol((prevState) => ({
                          ...prevState,
                          dataInicioUso: formatDateISO8601(value),
                        }))
                      }
                      required
                      maxDate={dayjs(new Date())}
                      minDate={dayjs(dataNascimento)}
                    />
                  </Stack>
                )}
              </Stack>
              <FieldAutocomplete
                label="Selecione os medicamentos usados pelo paciente"
                multiple
                options={medicamentosList}
                getOptionLabel={(option) => option.no_descricao || ""}
                freeSolo
                value={medicamentosUsados}
                setValue={(e, newValue) => {
                  const uniqueValues = [
                    ...new Set(
                      newValue.map((med) =>
                        med.no_descricao ? med.no_descricao : med
                      )
                    ),
                  ];

                  setMedicamentosUsados(uniqueValues);
                }}
                renderTags={() => null}
              />
              <Stack direction="row" flexWrap="wrap" sx={{ mt: 1 }}>
                {medicamentosUsados.map((v, index) => (
                  <Chip
                    sx={{
                      background: "#D3E3EB",
                      color: "#1E729F",
                      margin: "4px",
                    }}
                    key={v + index}
                    label={v}
                    onDelete={(value) => {
                      setMedicamentosUsados((prevState) => [
                        ...prevState.filter((data) => data !== v),
                      ]);
                    }}
                  />
                ))}
              </Stack>
              <Divider sx={{ mb: 2, mt: 2 }} />

              <Stack
                direction="row"
                sx={{ ...stylesForm.labelInput, marginBottom: 0 }}
              >
                Alergias ou reações adversas? <IconDiamond fill="#FC8518" />
              </Stack>
              <RadioGroup
                row
                aria-labelledby="alergiasOuReacoes"
                name="alergiasOuReacoes"
                onChange={(e) => {
                  setChecks((prevState) => ({
                    ...prevState,
                    alergiasOuReacoes: e.target.value === "true",
                  }));
                }}
                required
              >
                <FormControlLabel
                  value="true"
                  checked={checks.alergiasOuReacoes === true}
                  control={<Radio required />}
                  label="Sim"
                />
                <FormControlLabel
                  value="false"
                  checked={checks.alergiasOuReacoes === false}
                  control={<Radio required />}
                  label="Não"
                />
              </RadioGroup>
              {checks.alergiasOuReacoes && (
                <Stack>
                  <FormGroup
                    sx={{
                      display: "grid",
                      gridTemplateColumns: "1fr",
                      color: "#333333",
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={() =>
                            setChecks((prevState) => ({
                              ...prevState,
                              alimentos: !prevState.alimentos,
                            }))
                          }
                        />
                      }
                      label="Alimentos"
                      checked={checks.alimentos}
                    />

                    {checks.alimentos && (
                      <>
                        <FieldAutocomplete
                          multiple
                          options={[]}
                          getOptionLabel={(option) => ""}
                          freeSolo
                          value={alergiasOuReacoes.alimentos}
                          setValue={(e, newValue) => {
                            const uniqueValues = [
                              ...new Set(newValue.map((item) => item)),
                            ];
                            setAlergiasOuReacoes((prevState) => ({
                              ...prevState,
                              alimentos: uniqueValues,
                            }));
                          }}
                          renderTags={() => null}
                          placeholder="Digite alimento"
                        />

                        <Stack
                          direction="row"
                          flexWrap="wrap"
                          overflow="overlay"
                          gap="4px"
                          pr="5px"
                          mt="10px"
                        >
                          {alergiasOuReacoes.alimentos.map((v) => (
                            <Chip
                              sx={{
                                background: "#D3E3EB",
                                color: "#1E729F",
                                margin: "4px",
                              }}
                              key={v}
                              label={v}
                              onDelete={(valor) => {
                                setAlergiasOuReacoes((prevState) => ({
                                  ...prevState,
                                  alimentos: alergiasOuReacoes.alimentos.filter(
                                    (data) => data !== v
                                  ),
                                }));
                              }}
                            />
                          ))}
                        </Stack>
                      </>
                    )}

                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={() =>
                            setChecks((prevState) => ({
                              ...prevState,
                              medicamentos: !prevState.medicamentos,
                            }))
                          }
                        />
                      }
                      label="Medicamentos"
                      checked={checks.medicamentos}
                    />

                    {checks.medicamentos && (
                      <>
                        <FieldAutocomplete
                          multiple
                          options={substanciasList}
                          getOptionLabel={(option) =>
                            option.no_substancia || ""
                          }
                          freeSolo
                          value={alergiasOuReacoes.medicamentos}
                          setValue={(e, newValue) => {
                            const uniqueValues = [
                              ...new Set(
                                newValue.map((med) =>
                                  med.no_substancia ? med.no_substancia : med
                                )
                              ),
                            ];
                            setAlergiasOuReacoes((prevState) => ({
                              ...prevState,
                              medicamentos: uniqueValues,
                            }));
                          }}
                          renderTags={() => null}
                          placeholder="Digite"
                        />

                        <Stack
                          direction="row"
                          flexWrap="wrap"
                          overflow="overlay"
                          gap="4px"
                          pr="5px"
                          mt="10px"
                        >
                          {alergiasOuReacoes.medicamentos.map((v) => (
                            <Chip
                              sx={{
                                background: "#D3E3EB",
                                color: "#1E729F",
                                margin: "4px",
                              }}
                              key={v}
                              label={v}
                              onDelete={(valor) => {
                                setAlergiasOuReacoes((prevState) => ({
                                  ...prevState,
                                  medicamentos:
                                    alergiasOuReacoes.medicamentos.filter(
                                      (data) => data !== v
                                    ),
                                }));
                              }}
                            />
                          ))}
                        </Stack>
                      </>
                    )}

                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={() =>
                            setChecks((prevState) => ({
                              ...prevState,
                              outros: !prevState.outros,
                            }))
                          }
                        />
                      }
                      label="Outros"
                      checked={checks.outros}
                    />

                    {checks.outros && (
                      <>
                        <FieldAutocomplete
                          multiple
                          options={[]}
                          getOptionLabel={(option) => ""}
                          freeSolo
                          value={alergiasOuReacoes.outros}
                          setValue={(e, newValue) => {
                            const uniqueValues = [
                              ...new Set(newValue.map((item) => item)),
                            ];
                            setAlergiasOuReacoes((prevState) => ({
                              ...prevState,
                              outros: uniqueValues,
                            }));
                          }}
                          renderTags={() => null}
                          placeholder="Digite"
                        />

                        <Stack
                          direction="row"
                          flexWrap="wrap"
                          overflow="overlay"
                          gap="4px"
                          pr="5px"
                          mt="10px"
                        >
                          {alergiasOuReacoes.outros.map((v, index) => (
                            <Chip
                              sx={{
                                background: "#D3E3EB",
                                color: "#1E729F",
                              }}
                              key={v + index}
                              label={v}
                              onDelete={(valor) => {
                                setAlergiasOuReacoes((prevState) => ({
                                  ...prevState,
                                  outros: alergiasOuReacoes.outros.filter(
                                    (data) => data !== v
                                  ),
                                }));
                              }}
                            />
                          ))}
                        </Stack>
                      </>
                    )}
                  </FormGroup>
                </Stack>
              )}

              <Divider sx={{ mb: 2, mt: 2 }} />

              <Stack sx={{ mb: 2 }}>
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  sx={stylesForm.labelInput}
                >
                  Observações
                </Grid>
                <textarea
                  value={observacoes}
                  onChange={(e) => setObservacoes(e.target.value)}
                  style={{
                    height: "5rem",
                    border: "1px solid #1E729F",
                    borderRadius: "5px",
                    padding: 10,
                    resize: "vertical",
                  }}
                  variant="outlined"
                />
              </Stack>
              <Button variant="contained" type="submit">
                Salvar
              </Button>
            </Box>
          }
        />

        {consulta && (
          <ModalDialogs
            open={openModalConsulta}
            onClose={() => setOpenModalConsulta(false)}
            onActionPrimary={() => handleIniciarConsulta(false)}
            onActionSecondary={() => handleIniciarConsulta(true)}
            primaryButtonText="Iniciar consulta instantânea"
            secondaryButtonText={
              consulta.status === 1
                ? "Iniciar consulta agendada"
                : "Continuar consulta agendada"
            }
            title="Consulta agendada"
            maxWidth="800px"
            body={
              <Stack sx={{ width: { xs: "100%", md: "800px" } }}>
                <Typography
                  textAlign={"center"}
                  component="h3"
                  style={styles.subtitle}
                >
                  Você tem uma consulta agendada!
                </Typography>

                <Grid
                  container
                  gap={"24px 16px"}
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
                    boxSizing: "border-box !important",
                    padding: 3,
                    textAlign: "left",
                  }}
                  width="100%"
                >
                  <Grid item>
                    <Stack spacing={1}>
                      <Typography
                        sx={{ ...stylesForm.labelInput, marginBottom: 0 }}
                      >
                        Local de atendimento
                      </Typography>
                      <Typography sx={stylesForm.input}>
                        {consulta?.estabelecimento &&
                          consulta.estabelecimento.nome}
                      </Typography>
                    </Stack>
                  </Grid>
                  <Grid item>
                    <Stack spacing={1}>
                      <Typography
                        sx={{ ...stylesForm.labelInput, marginBottom: 0 }}
                      >
                        Profissional responsável
                      </Typography>
                      <Typography sx={stylesForm.input}>
                        {consulta?.vinculo && consulta.vinculo.usuario.nome}
                      </Typography>
                    </Stack>
                  </Grid>
                  <Grid item>
                    <Stack spacing={1}>
                      <Typography
                        sx={{ ...stylesForm.labelInput, marginBottom: 0 }}
                      >
                        Paciente
                      </Typography>
                      <Typography sx={stylesForm.input}>
                        {consulta.paciente.nome ?? "---"}
                      </Typography>
                    </Stack>
                  </Grid>
                  <Grid item>
                    <Stack spacing={1}>
                      <Typography
                        sx={{ ...stylesForm.labelInput, marginBottom: 0 }}
                      >
                        Tipo da consulta
                      </Typography>
                      <Typography sx={stylesForm.input}>
                        {consultTypes[`${consulta.id_categoria}`] ?? "---"}
                      </Typography>
                    </Stack>
                  </Grid>
                  <Grid item>
                    <Stack spacing={1}>
                      <Typography
                        sx={{ ...stylesForm.labelInput, marginBottom: 0 }}
                      >
                        Equipe de saúde interna
                      </Typography>
                      {consulta?.participantes.map(
                        (item) =>
                          consulta?.estabelecimento.id ===
                            item?.estabelecimento.id && (
                            <Typography key={item.id} sx={stylesForm.input}>
                              {item?.usuario?.nome} <br />
                              {item?.perfil?.descricao}
                            </Typography>
                          )
                      )}
                    </Stack>
                  </Grid>
                  <Grid item>
                    <Stack spacing={1}>
                      <Typography
                        sx={{ ...stylesForm.labelInput, marginBottom: 0 }}
                      >
                        Equipe de saúde externa
                      </Typography>
                      {consulta?.participantes.map(
                        (item) =>
                          consulta?.estabelecimento.id !==
                            item?.estabelecimento.id && (
                            <Typography key={item.id} sx={stylesForm.input}>
                              {item?.usuario?.nome} <br />
                              {item?.perfil?.descricao} <br />
                              {item?.estabelecimento?.nome}
                            </Typography>
                          )
                      )}
                    </Stack>
                  </Grid>
                  <Grid item>
                    <Stack spacing={1}>
                      <Typography
                        sx={{ ...stylesForm.labelInput, marginBottom: 0 }}
                      >
                        Data e horário
                      </Typography>
                      <Typography sx={stylesForm.input}>
                        {dayjs(consulta.dataConsulta.split("T")[0])
                          .locale("pt-br")
                          .format("dddd, D [de] MMMM [de] YYYY")}{" "}
                        ás {consulta.inicio}
                      </Typography>
                    </Stack>
                  </Grid>
                </Grid>

                {/* <Stack
                  component={"ul"}
                  sx={{
                    "& li": {
                      color: "#737373",
                      fontSize: "18px",
                    },
                    "& strong": {
                      color: "#333333",
                    },
                  }}
                >
                  <Typography component={"li"}>
                    <Typography component="strong" fontWeight="700">
                      Paciente:
                    </Typography>{" "}
                    {consulta.paciente.nome}
                  </Typography>
                  <Typography component={"li"}>
                    <Typography component="strong" fontWeight="700">
                      Data:
                    </Typography>{" "}
                    {dayjs(consulta.data_consulta)
                      .locale("pt-br")
                      .format("dddd, D [de] MMMM [de] YYYY")}{" "}
                  </Typography>
                  <Typography component={"li"}>
                    <Typography component="strong" fontWeight="700">
                      Hora:
                    </Typography>{" "}
                    {consulta.inicio}
                  </Typography>
                  {consulta?.participantes.length > 1 && (
                    <Typography component={"li"}>
                      <Typography component="strong" fontWeight="700">
                        Multidisciplinar
                      </Typography>
                      <Typography component={"ul"}>
                        {consulta?.participantes.map((p) => (
                          <Typography
                            component={"li"}
                            textTransform={"capitalize !important"}
                          >
                            <Typography component="strong" fontWeight="700">
                              Nome:{" "}
                            </Typography>
                            {p?.usuario.nome} <br />
                            <Typography component="strong" fontWeight="700">
                              Especialidade:{" "}
                            </Typography>
                            {p?.perfil.descricao}
                            <br />
                            <Typography component="strong" fontWeight="700">
                              Estabelecimento:{" "}
                            </Typography>
                            <Typography
                              component={"span"}
                              sx={{
                                textTransform: "",
                              }}
                            >
                              {p?.estabelecimento.fantasia
                                .split(" ")
                                .map(
                                  (palavra) =>
                                    palavra.charAt(0).toUpperCase() +
                                    palavra.slice(1).toLowerCase()
                                )
                                .join(" ")}
                            </Typography>
                          </Typography>
                        ))}
                      </Typography>
                    </Typography>
                  )}
                  <Typography component={"li"}>
                    <Typography component="strong" fontWeight="700">
                      Cadastrada por:
                    </Typography>
                    <Typography component={"ul"}>
                      <Typography component={"li"}>
                        <Typography component="strong" fontWeight="700">
                          Nome:{" "}
                        </Typography>
                        {consulta.vinculo.usuario.nome}
                      </Typography>
                      <Typography component={"li"}>
                        <Typography component="strong" fontWeight="700">
                          Especialidade:{" "}
                        </Typography>
                        {consulta.vinculo.perfil.descricao}
                      </Typography>
                    </Typography>
                  </Typography>
                </Stack> */}
              </Stack>
            }
          />
        )}

        <Backdrop
          sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
          open={loadingBackdrop}
        >
          <CircularProgress color="inherit" />
        </Backdrop>

        {!!snackbar && (
          <Snackbar
            open
            onClose={() => {}}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert {...snackbar} onClose={() => setSnackbar(null)} />
          </Snackbar>
        )}
      </Box>
    </Box>
  );
}
